import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;
